module.exports = __webpack_public_path__ + "media/images/carousel/banner_5-fa4fd5d156940c1c52cd93b0383ddffe.jpg";